<lms-breadcrumb label="customizations.create"></lms-breadcrumb>
<lms-toolbar> </lms-toolbar>

<div class="row">
  <div class="col s12">
    <lms-customization-editor (saved)="onSave($event)"> </lms-customization-editor>
  </div>
</div>
